import { FC, ReactNode } from 'react';
import { AuthErrorEnum } from './auth-error.interface';
import NoEmailErrorComponent from './errors/no-email-error.component';
import VerifyEmailComponent from './errors/verify-email-error.component';
import DefaultAuthErrorComponent from './errors/default-auth-error.component';
import UnsupportedTenantErrorComponent from './errors/unsupported-tenant-error.component';
import Error403Component from '../403/error-403.component';

const ERROR_ENUM_KEY = 'error_description';

const errorComponentMap: Record<AuthErrorEnum, ReactNode> = {
  [AuthErrorEnum.NoEmail]: NoEmailErrorComponent,
  [AuthErrorEnum.NoCiam]: Error403Component,
  [AuthErrorEnum.EmailVerification]: VerifyEmailComponent,
  [AuthErrorEnum.UnsupportedTenant]: UnsupportedTenantErrorComponent,
  [AuthErrorEnum.Default]: DefaultAuthErrorComponent,
};

const AuthErrorComponent: FC = () => {
  const queryParameters = new URLSearchParams(window.location.search);

  const ErrorComponent =
    errorComponentMap[queryParameters.get(ERROR_ENUM_KEY)] ??
    errorComponentMap[AuthErrorEnum.Default];
  return <ErrorComponent />;
};

export default AuthErrorComponent;
